import React, { useMemo, useState } from 'react';
import { Button, Drawer, Grid } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Table from '@components/Table';
import CustomTag from '@components/CustomTag';

const { useBreakpoint } = Grid;

type EventsListDrawerType = {
  transaction?: any;
};

const EventsListDrawer = ({ transaction }: EventsListDrawerType) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('transfers');
  const screens = useBreakpoint();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const columns = useMemo(() => {
    const allColumns = [
      {
        title: t('acquiring.table.messageId'),
        align: 'center' as const,
        dataIndex: 'messageId',
      },
      {
        title: t('acquiring.table.isRequest'),
        align: 'center' as const,
        dataIndex: 'isRequest',
        render: (value?: boolean) => (
          <>
            {value
              ? t('acquiring.eventDrawer.isRequest.yes')
              : t('acquiring.eventDrawer.isRequest.no')}
          </>
        ),
      },
      {
        title: t('acquiring.table.status'),
        align: 'center' as const,
        dataIndex: 'status',
        render: (value?: string) => (
          <CustomTag color={value === 'SUCCESS' ? 'green' : 'red'}>
            {t(`table.result.options.${value}`)}
          </CustomTag>
        ),
      },
      {
        title: t('acquiring.table.totalBytes'),
        align: 'center' as const,
        dataIndex: 'totalBytes',
      },
      {
        title: t('acquiring.table.duration'),
        align: 'center' as const,
        dataIndex: 'duration',
        render: (value: number) => value && `${value} ms`,
      },
    ].filter(col => col);

    return allColumns;
  }, [t]);

  return (
    <>
      <Button onClick={showDrawer} style={{ padding: '0 8px' }}>
        <UnorderedListOutlined />
      </Button>
      <Drawer
        title={t('acquiring.eventDrawer.details')}
        placement="right"
        onClose={onClose}
        open={open}
        width={screens?.xs ? '90%' : '60%'}
      >
        <Table
          // @ts-ignore
          columns={columns}
          data={transaction?.eventList || []}
          tableKey="transferAcquiriringEvents"
          title={t('acquiring.eventDrawer.title')}
          pagination={{
            page: 1,
            linesPerPage: transaction?.eventList?.length,
            total: transaction?.eventList?.length,
          }}
        />
      </Drawer>
    </>
  );
};

export default EventsListDrawer;
